<template>
  <div class="nuttrema-widget nuttrema-widget--notices-danger" v-show="showNotice || showPurchase">
    <template>
      <h4 class="nuttrema-widget__sup_title">{{ $t('label.warning') }}</h4>

      <h2 class="nuttrema-widget__title">
        <template v-if="_get(NoticesInstance, 'data.instance_restrictions') === 'on_trial'">
          {{ $tc('label.your_trial_will_expire_soon', expireMessage) }}
        </template>
        <template v-else-if="showPurchase">
          {{ $tc('label.your_subscription_will_expire_soon', 2) }}
        </template>
        <template v-else>
          {{ $tc('label.your_subscription_will_expire_soon', expireMessage) }}
        </template>
      </h2>

      <ul class="nuttrema-widget__notes">
        <li>
          <router-link
             tag="a"
            :to="{ name: 'instance-subscription-purchase-new' }">
            <div class="nuttrema-widget__notice">
              <div class="notice__icon">
                <nuttrema-iconica-sidebar-link icon="fal fa-credit-card"></nuttrema-iconica-sidebar-link>
              </div>
              <div class="notice__text">
                <div class="notice__text--title">{{ $t('label.purchase_new_subscription') }}</div>
                <div class="notice__text--info">{{ $t('label.in_only_two_steps') }}</div>
              </div>
              <div class="notice__action">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import { get, has, isNil } from 'lodash';

import { SCOPES } from 'constants/roles';
import { checkScopesPermition } from 'utils/check-permissions';
import { showInstancePurchaseOption } from 'utils/check-purchase';

import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

import AbstractWidget from './abstract-widget';

export default {
  name: 'widget-notices-subscription-expiry',
  mixins: [
    AbstractWidget,
  ],
  props: {
    NoticesInstance: {
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaIconicaSidebarLink,
  },
  data: () => ({
    expireMessage: null,
  }),
  computed: {
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
    showNotice() {
      const scopes = get(this.PersonalProfile, 'meta.permissions.scopes', []);
      return checkScopesPermition(scopes, SCOPES.INSTANCE_OWNER) && !isNil(this.expireMessage);
    },
    showPurchase() {
      const scopes = get(this.PersonalProfile, 'meta.permissions.scopes', []);
      const instanceRestrictions = get(this.NoticesInstance, 'data.instance_restrictions');
      const subscriptionExpiry = has(this.NoticesInstance, 'data.subscription_expiry');

      const expire = !isNil(subscriptionExpiry) && subscriptionExpiry < 0;

      return showInstancePurchaseOption(scopes, instanceRestrictions, expire, ['in_grace', 'no_subscription']);
    },
  },
  created() {
    const expire = get(this.NoticesInstance, 'data.subscription_expiry');

    // 0, 1, 2 will expire
    // -1, -2, -3 expire

    this.expireMessage = !isNil(expire) ? (Number(expire) < 0 ? 2 : 1) : null;
  },
};
</script>

<style lang="scss" scoped>
  @import './abstract-widget';
</style>




// WEBPACK FOOTER //
// src/components/ui/widgets/widget-notices-subscription-expiry.vue